// @flow @format
import {handleActions} from 'lib/redux-actions';

import type {User} from 'lib/cloner-api';

export type State = {
	entities: {[id: ?string]: User},
	entitiesFetching: {[group: number]: boolean},
	byGroup: {[group: ?number]: User[]},
};

export type FetchUsersAction = {
	type: string,
	groupId: number,
};

type AddUsersAction = {
	type: string,
	groupId: number,
	payload: User[],
};

type RequestUsersAction = {
	type: string,
	groupId: number,
};

// async actions
export const FETCH_USERS = 'FETCH_USERS';

export const fetchUsers = (groupId: number): FetchUsersAction => ({
	groupId,
	type: FETCH_USERS,
});

// actions
const ADD_USERS = 'ADD_USERS';
const REQUEST_USERS = 'REQUEST_USERS';

export const addUsers = (groupId: number, users: User[]): AddUsersAction => ({
	groupId,
	type: ADD_USERS,
	payload: users,
});

export const requestUsers = (groupId: number): RequestUsersAction => ({
	groupId,
	type: REQUEST_USERS,
});

export const initialState: State = {
	entities: {},
	entitiesFetching: {},
	byGroup: {},
};

const reducer = handleActions(
	{
		[REQUEST_USERS]: (state: State, action: RequestUsersAction): State => {
			const entitiesFetching = {...state.entitiesFetching};

			entitiesFetching[action.groupId] = true;

			return {...state, entitiesFetching};
		},
		[ADD_USERS]: (state: State, action: AddUsersAction): State => {
			const entities = {...state.entities};
			const byGroup = {...state.byGroup};
			const entitiesFetching = {...state.entitiesFetching};

			byGroup[action.groupId] = [];
			entitiesFetching[action.groupId] = false;

			for (const user of action.payload) {
				entities[user.login] = user;
				byGroup[action.groupId].push(user);
			}

			return {...state, entities, byGroup, entitiesFetching};
		},
	},
	initialState,
);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/entities/users.js